var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a-button-group',{staticStyle:{"width":"100%"},attrs:{"size":"medium"}},_vm._l((_vm.tenants),function(t){return _c('a-button',{key:t.id,attrs:{"type":_vm.tenant.name == t.name ? 'primary' : 'secondary',"block":""},on:{"click":function($event){return _vm.setTenant(t)}}},[_vm._v(_vm._s(t.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }